






























import {Component, Vue} from 'vue-property-decorator';
import { ClickEventArgs } from '@syncfusion/ej2-vue-navigations';
import CFMGridPage from '@/scripts/CFMGridPage'

import * as blockui from '@/helpers/block-ui'
import * as dateFormat from '@/helpers/dateFormat';

import { CFMDTOFreezeView, CFMCoreEnumsEnumFreezeStatus } from '@/scripts/services/ClientApiAuto'
import { FREEZE_STATUS_VIEW } from '@/helpers/freeze';
import FreezeDialog, { FreezeEditTarget } from './FreezeDialog.vue';

/** Tarihler duvar saati; bkz. dateFormat.parseWallClock. */
const toDate = (value?: string | null): Date | null => dateFormat.parseWallClock(value);

type FreezeRow = Omit<CFMDTOFreezeView, 'StartDate' | 'EndDate' | 'CreatedDate' | 'ModifiedDate'> & {
    Id: number;
    StartDate: Date;
    EndDate: Date;
    CreatedDate: Date;
    ModifiedDate: Date | null;
    StatusText: string;
};

@Component<FreezeDefinition>({
    components: {
        'freeze-dialog': FreezeDialog,
    },
})
export default class FreezeDefinition extends CFMGridPage<FreezeRow> {
    entityType = "Freeze";
    sorts: {field: string, direction: string}[] = [{ field: "StartDate", direction: "Descending" }];

    /** Liste kucuk; sayfalama, filtre ve siralama istemcide yapiliyor. */
    freezes: FreezeRow[] = [];

    /** Bos ise dialog yeni donem baslatir, doluysa o donemi duzenler. */
    editTarget: FreezeEditTarget | null = null;

    /**
     * Kayitlar silinmez ve manuel bitirilmez: yalnizca "Freeze Baslat" ve "Duzenle" var. Erken
     * bitirmek bitis tarihini duzenlemektir.
     */
    get toolbarItems() {
        return this.toolbar
            .filter(item => item.id !== 'Delete')
            .map(item => item.id === 'Add'
                ? { ...item, text: this.translate('start_freeze'), tooltipText: this.translate('start_freeze') }
                : item);
    }

    async mounted() {
        await this.refreshGrid();
    }

    async refreshGrid() {
        blockui.pageBlock(this);
        try {
            const response = await this.apiClient.freeze.freezeGetList();
            if (!response.data.IsSuccess) {
                toastr.error(response.data.Message ? response.data.Message : 'Error');
                return;
            }
            this.freezes = (response.data.Data || []).map(x => ({
                ...x,
                Id: <number>x.Id,
                StartDate: <Date>toDate(x.StartDate),
                EndDate: <Date>toDate(x.EndDate),
                CreatedDate: <Date>toDate(x.CreatedDate),
                ModifiedDate: toDate(x.ModifiedDate),
                StatusText: x.Status ? this.translate(FREEZE_STATUS_VIEW[x.Status].label) : '',
            }));
        }
        catch (e) {
            toastr.error(e);
        }
        finally {
            blockui.unBlockPage();
        }
    }

    async openDialog(target: FreezeEditTarget | null) {
        this.editTarget = target;
        this.isDialogActive = true;
        await this.$nextTick();
        (<FreezeDialog>this.$refs.freezeDialog).showDialog();
    }

    edit(row: FreezeRow) {
        this.openDialog(row);
    }

    recordDoubleClick(args: any) {
        this.edit(args.rowData);
    }

    async toolbarClick(args: ClickEventArgs) {
        if (args.item.id === 'Add') {
            this.openDialog(null);
        } else if (args.item.id === 'Edit') {
            const selectedRecords = (<any>this.$refs.grid).getSelectedRecords();
            if (selectedRecords.length > 0) {
                this.edit(selectedRecords[0]);
            }
        }
        this.toolbarClickBase(args);
    }

    statusTemplate() {
        return {
            template: Vue.component('freezeStatusColumnTemplate', {
                template: `<span v-if="view" class="m-badge m-badge--wide" :class="view.badge">{{ data.StatusText }}</span>`,
                computed: {
                    view() {
                        const self = <any>this;
                        return FREEZE_STATUS_VIEW[<CFMCoreEnumsEnumFreezeStatus>self.data.Status];
                    },
                },
            }),
        };
    }

    commandTemplate() {
        const parentComponent = this;
        return {
            template: Vue.component('freezeCommandColumnTemplate', {
                template: `
                    <div>
                        <button type="button" @click="editFreeze" :title="translate('edit')" class="e-lib e-btn e-control e-icon-btn">
                            <i class="fa fa-edit"></i>
                        </button>
                    </div>
                    `,
                methods: {
                    editFreeze() {
                        const self = <any>this;
                        parentComponent.edit(self.data);
                    },
                },
            }),
        };
    }
}
